<template>
  <section id="event-section" class="event">
    <h2 class="event__title">Event</h2>
    <InternalServerError
      v-if="isCreateServerError"
      :lang="lang"
    ></InternalServerError>
    <ul v-else class="event__list">
      <li
        class="event__list--item"
        v-for="(eventData, index) in emptyTextObj(eventListData)"
        :key="index"
      >
        <router-link
          :to="{
            path: `/${langPath}${
              $route.path.includes('company') ? 'company/' : ''
            }event/${eventData.code}`,
          }"
        >
          <figure class="event-logo">
            <img
              :src="`https://tmf-virtualrun.jp/images/${
                $route.path.includes('company') ? 'company/' : ''
              }${eventData.text.event_image_file_name}`"
              alt=""
              width="200"
              height="200"
            />
          </figure>
          <div
            class="event-label"
            :style="`background-color: ${eventData.label.event_label_color};`"
          >
            <span>{{ eventData.label.event_label_name }}</span>
            <span
              class="right-triangle"
              :style="`border-color: ${eventData.label.event_label_color} transparent transparent transparent;`"
            ></span>
          </div>
          <h4 class="event-name">
            {{ eventData.name }}
          </h4>
          <div class="event-date">
            {{ eventData.text.event_date }}
          </div>
          <p
            v-if="eventData.text"
            class="event-entry"
            v-html="eventData.text.event_entry_period"
          ></p>
          <ul class="event-category-label__list" v-if="eventData.text">
            <li class="event-category-label__list--item">
              {{ eventData.text.event_category_label }}
            </li>
          </ul>
        </router-link>
      </li>
    </ul>
  </section>
</template>

<script>
import { RepositoryFactory } from "../../../api/RepositoryFactory";
import InternalServerError from "../../common/status/InternalServerError";
export default {
  data() {
    return {
      eventListData: [],
      isCreateServerError: false,
    };
  },
  // イベントリストを取得
  async created() {
    const EventRepository = RepositoryFactory.get("event");
    const isCompany = this.$route.path.includes("company");
    const params = {
      lang: this.lang,
      is_company_event: isCompany || "",
      company_user_name: this.userName || "",
    };
    const response = await EventRepository.getEventList(params).catch((e) => {
      if (e.response.status === 500) {
        return (this.isCreateServerError = true);
      }
    });
    this.eventListData = response.data.items;
  },
  methods: {
    emptyTextObj(eventListData) {
      return eventListData.filter((event) => event.text);
    },
  },
  props: {
    lang: {
      type: String,
    },
    langPath: {
      type: String,
    },
    userName: {
      type: String,
    },
  },
  components: {
    InternalServerError,
  },
  name: "EventList",
};
</script>

<style scoped lang="scss">
$defaultFontColor: #000;
.event {
  /*スムーズスクロール時の余白を保つ考慮*/
  margin: 80px 0 0 0;
  padding: 20px 0 0 0;
  text-align: center;

  &__title {
    display: inline-block;
    padding: 0;
    line-height: 1;
    font-size: 100px;
    font-weight: 900;
    &::after {
      content: "";
      display: block;
      height: 10px;
      background: url("../../../assets/images/border/border_event.svg");
      margin-top: 8px;
    }
  }

  &__list {
    margin: 80px 0 0 0;
    text-align: left;

    &--item {
      padding: 0 0 28px 0;
      border-bottom: solid 1px $defaultFontColor;
      position: relative;

      &:hover {
        background-color: #eee;
        transition-duration: 0.3s;
      }

      &:not(:first-of-type) {
        margin: 30px 0 0 0;
      }

      .event-logo {
        padding: 18px 10px;
        border: solid 1px #eee;
        position: absolute;
        top: 50%;
        right: 0;
        transform: translateY(-50%);
      }

      .event-label {
        display: inline-block;
        min-width: 178px;
        padding: 12px 16px;
        line-height: 1;
        font-size: 16px;
        font-weight: bold;
        color: #fff;
        background-color: #53996a;
        position: relative;

        .right-triangle {
          width: 0;
          height: 0;
          border-style: solid;
          border-width: 40px 16px 0 0;
          border-color: #53996a transparent transparent transparent;
          position: absolute;
          top: 0;
          right: -16px;
        }
      }

      .event-name {
        margin: 20px 0 0 0;
        font-size: 24px;
        font-weight: bold;
        line-height: 1.33;
        width: 75%;
      }

      .event-date {
        margin: 16px 0 0 0;
        padding: 10px 0 0 0;
        font-size: 20px;
        font-weight: bold;
        line-height: 1.6;
        position: relative;

        &::before {
          content: "";
          width: 60px;
          height: 6px;
          position: absolute;
          top: 0;
          left: 0;
          background-color: $defaultFontColor;
        }
      }

      .event-entry {
        margin: 10px 240px 10px 0;
        font-size: 16px;
        font-weight: 500;
        line-height: 1.5;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pc/top/EventList.vue